// extracted by mini-css-extract-plugin
module.exports = {"root":"MediaCollectionBody_root__D8mfH","navigation":"MediaCollectionBody_navigation__YZ1P_","media":"MediaCollectionBody_media__Hlgg9","asset":"MediaCollectionBody_asset__xEV51"};